import React from 'react'
import BeneficiaryContainer from '../BeneficiaryContainer'
import classes from './BeneficiaryClasses.module.css'
import { ClassCard } from '../../../components/Cards/GeneralCard/Card'
import emptyIcon from '../../../assets/images/beneficiary-my-classes-empty-state.svg'

const BeneficiaryClasses = () => {
    return (
        <BeneficiaryContainer>
            <div className={classes.topBar}>
                <h1 className={classes.topBarTitle}>My Classes</h1>
            </div>
            <div className={classes.empty}>
                <img src={emptyIcon} alt="No classes" />
                <h3 className={classes.emptyText}>Nothing here</h3>
                <p className={classes.emptySubtext}>
                    You have not been invited to any class
                </p>
            </div>
            <div className={classes.classes}>
                <ClassCard
                    url={'https://i.picsum.photos/id/549/300/200.jpg'}
                    title={
                        '12 Tips to Help You Capture Stunning Landscape Photos'
                    }
                    category={'HUMAN RESOURCES'}
                    price={5000}
                    attendees={50}
                    date={'2019-10-01T00:00:00.000Z'}
                />
            </div>
        </BeneficiaryContainer>
    )
}

export default BeneficiaryClasses
